import { Component, OnInit } from '@angular/core';
import { Service } from '../models/service';
import { LoadingService } from '../../services/loading.service';
import { ServiceService } from '../services/service.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'asv-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {
  services: Service[] = [];

  constructor(
    private loadingService: LoadingService,
    private servicesService: ServiceService,
    private translateService: TranslateService,
  ) {
    loadingService.show();
    servicesService.services.subscribe((list: Service[]) => {
      this.services = list;
    });
    servicesService.getServices();
  }

  ngOnInit() { }

  onDeleteService(id) {
    let message: string;
    this.translateService.get('service.actions.delete.confirm').subscribe((res: string) => {
      message = res;
    });
    const confirmed = confirm(message);
    if (confirmed) {
      this.loadingService.show();
      this.servicesService.delete(id);
    }
  }
}
